// extracted by mini-css-extract-plugin
export default {"container":"CardUltimas_container__0HZ36","imagen":"CardUltimas_imagen__obh-h","img":"CardUltimas_img__nPxEC","infiltrado":"CardUltimas_infiltrado__u8dAr"};